import React from 'react';
import { Link } from 'gatsby';
import styles from './Session.module.scss';
import cnames from 'classnames';
import GoChevronRight from 'react-icons/lib/go/chevron-right';

import defaultShareImage from '../../../assets/images/default-share-image.jpg';

const Session = ({name, stream, path, image, className}) => {
  return (
    <Link className={cnames(styles.session, className, {
      [styles.borderCrossings]: stream === 'Border Crossings'
    })} to={path}>
      <img src={image || defaultShareImage} />
  { stream === 'Border Crossings' && <div className={styles.borderCrossingsBanner}>Border Crossings</div> }
      <div className={styles.sessionInner}>
        <div className={styles.title}>
          {name}
        </div>
      </div>
      <div className={styles.moreInfo}>
          MORE INFO <GoChevronRight />
      </div>
    </Link>
  );
};

export default Session;